import { render, staticRenderFns } from "./ExperimentV2.vue?vue&type=template&id=36412642&scoped=true&"
import script from "./ExperimentV2.vue?vue&type=script&lang=js&"
export * from "./ExperimentV2.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/project-detail.css?vue&type=style&index=0&id=36412642&scoped=true&lang=css&"
import style1 from "./ExperimentV2.vue?vue&type=style&index=1&id=36412642&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36412642",
  null
  
)

export default component.exports